import { betterstartDir } from '@cli-utils/paths.js'

export function snapshotRoot(cwd: string): string {
  return betterstartDir(cwd, 'snapshots')
}
